import React from 'react';
import { motion } from 'framer-motion';
import { FileSpreadsheet } from 'lucide-react';
export function Solution() {
  return <section className="py-10 md:py-20 bg-stone-50 border-t border-gray-100" data-id="element-188">
      <div className="container mx-auto px-4 md:px-6" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center" data-id="element-190">
          <div className="inline-flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-white rounded-full shadow-sm border border-gray-100 mb-4 md:mb-6" data-id="element-191">
            <FileSpreadsheet className="w-4 h-4 md:w-5 md:h-5 text-teal-600" data-id="element-192" />
            <span className="text-xs md:text-sm font-medium text-gray-600" data-id="element-193">
              Google Sheets Template
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6" data-id="element-194">
            Un sistema simple para ordenar tus finanzas personales
          </h2>
          <div className="space-y-2 md:space-y-4 text-sm md:text-lg text-gray-600" data-id="element-195">
            <p data-id="element-196">
              Esta plantilla no es para contadores ni expertos en Excel. Está
              diseñada para
              <span className="font-semibold text-gray-800" data-id="element-197">
                {' '}
                personas reales
              </span>{' '}
              con gastos y deudas reales.
            </p>
            <p data-id="element-198">
              Olvidate de fórmulas complejas o software difícil de entender. Acá
              solo ingresás tus datos y automáticamente obtenés la claridad que
              necesitás para tomar el control.
            </p>
            <p data-id="element-199">
              Es el puente entre el caos financiero y la tranquilidad mental de
              saber exactamente dónde estás parado.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}